var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29289 5.3134C5.68342 4.92288 6.31658 4.92288 6.70711 5.3134L12 10.6063L17.2929 5.3134C17.6834 4.92288 18.3166 4.92288 18.7071 5.3134C19.0976 5.70393 19.0976 6.33709 18.7071 6.72761L13.4142 12.0205L18.7071 17.3134C19.0976 17.7039 19.0976 18.3371 18.7071 18.7276C18.3166 19.1181 17.6834 19.1181 17.2929 18.7276L12 13.4347L6.70711 18.7276C6.31658 19.1181 5.68342 19.1181 5.29289 18.7276C4.90237 18.3371 4.90237 17.7039 5.29289 17.3134L10.5858 12.0205L5.29289 6.72761C4.90237 6.33709 4.90237 5.70393 5.29289 5.3134Z",
    fill: "#676767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/iconClose.11707efa737dc5a44d0436193dde8751.svg";
export { ForwardRef as ReactComponent };